import apiClient from "./apiClient";

export const chatService = {
  /**
   * Send user prompt to the AI Chatbot
   * @param {Object} payload - { message, history, conversationId, signal }
   */
  async sendMessage({ message, history = [], conversationId, signal }) {
    const response = await apiClient.post(
      "/chat/message",
      {
        message,
        history,
        conversationId,
      },
      { signal }
    );
    return response.data?.data || response.data;
  },

  /**
   * Get chatbot engine & model status
   */
  async getStatus() {
    const response = await apiClient.get("/chat/status");
    return response.data?.data || response.data;
  },

  /**
   * Get all past chat sessions for the logged-in user
   */
  async getSessions() {
    const response = await apiClient.get("/chat/sessions");
    return response.data?.data || [];
  },

  /**
   * Get all messages for a specific chat session
   * @param {string} sessionId
   */
  async getSessionMessages(sessionId) {
    const response = await apiClient.get(`/chat/sessions/${sessionId}`);
    return response.data?.data || [];
  },

  /**
   * Delete a specific conversation session
   * @param {string} sessionId
   */
  async deleteSession(sessionId) {
    const response = await apiClient.delete(`/chat/sessions/${sessionId}`);
    return response.data;
  },

  /**
   * Delete all conversation sessions on a specific date (YYYY-MM-DD)
   * @param {string} date - 'YYYY-MM-DD'
   */
  async deleteSessionsByDate(date) {
    const response = await apiClient.delete(`/chat/sessions/by-date?date=${encodeURIComponent(date)}`);
    return response.data;
  },

  /**
   * Clear all conversation history for the logged-in user
   */
  async clearAllSessions() {
    const response = await apiClient.delete("/chat/sessions");
    return response.data;
  },
};

export default chatService;
